import { filterMenuModuleRecords } from './outletMenuModuleRegistry';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const normalizeModuleRecord = module => {
  if (!module || typeof module !== 'object') {
    return null;
  }

  const rawId = module.ID ?? module.id ?? module.Id ?? module.value ?? module.module_id ?? module.moduleId;
  const parsedId = Number.parseInt(rawId, 10);
  if (!Number.isFinite(parsedId) || parsedId <= 0) {
    return null;
  }

  return {
    ...module,
    ID: parsedId,
    Modulename: module.Modulename ?? module.modulename ?? module.module_name ?? module.label ?? '',
    Modulelink: module.Modulelink ?? module.modulelink ?? module.module_link ?? '',
  };
};

export const fetchActiveOutletModules = async (token, outletId) => {
  const parsedOutletId = Number.parseInt(outletId, 10);
  if (!token || !Number.isFinite(parsedOutletId) || parsedOutletId <= 0) {
    return [];
  }

  const response = await fetch(`${API_BASE_URL}active-outlet-modules`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ id_outlet: parsedOutletId }),
  });

  if (response.status === 404) {
    return [];
  }

  let data = null;
  try {
    data = await response.json();
  } catch (error) {
    if (!response.ok) {
      throw new Error('Failed to load active outlet modules.');
    }
  }

  if (!response.ok) {
    throw new Error(data?.message || 'Failed to load active outlet modules.');
  }

  if ((data?.error === '0' || data?.error === 0) && Array.isArray(data.results)) {
    return filterMenuModuleRecords(
      data.results
      .map(normalizeModuleRecord)
      .filter(Boolean)
    );
  }

  throw new Error(data?.message || 'Failed to load active outlet modules.');
};
